import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  SelectedSeatInformation,
  SelectedSeatInformationSegment,
  ServicingSeatmapChildSeatNotSelectableConfirmationModalComponent,
} from '@common/components';
import { ChildSeatNotSelectableConfirmationModalPayload } from '@common/components/reservation/seatmap/modal/servicing-seatmap-select-child-seat-modal/servicing-seatmap-select-child-seat-modal.state';
import { apiEventAll } from '@common/helper';
import { CurrentSeatmapService, DeliveryInformationStoreService, GetOrderStoreService } from '@common/services';
import { DeliveryInformationState } from '@common/store';
import { RoutesResRoutes } from '@conf/routes.config';
import { LModalContentsWidthType, ModalType } from '@lib/components';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService, ModalService } from '@lib/services';
import { GetOrderRequest } from 'src/sdk-servicing';
import { NotSelectableChildSeatInfo } from '../../../../common/interfaces/reservation/current-seatmap/not-selectable-child-seat-info';

@Component({
  selector: 'asw-seatmap-test',
  templateUrl: './seatmap-test.component.html',
  styleUrls: ['./seatmap-test.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeatmapTestComponent extends SupportComponent implements OnInit {
  public text = '';

  reload(): void {}
  init(): void {}
  destroy(): void {}

  constructor(
    private _common: CommonLibService,
    private _router: Router,
    private _getOrderStoreService: GetOrderStoreService,
    private _currentSeatmapService: CurrentSeatmapService,
    private _deliveryInformationStoreService: DeliveryInformationStoreService,
    private _modalService: ModalService
  ) {
    super(_common);
  }

  /**
   * APIレスポンス取得にシートマップ画面に遷移する
   */
  public goToSeatmapPage() {
    this.setGetOrderResponse(() => {
      this.setDeliveryInformation();
      this._router.navigateByUrl(RoutesResRoutes.SEATMAP);
    });
  }

  /** チャイルドシート選択不可確認モーダルを開く */
  public openChildSeatNotSelectableConfirmationModal() {
    const modalPart = this._modalService.defaultBlockPart(
      ServicingSeatmapChildSeatNotSelectableConfirmationModalComponent
    );
    modalPart.type = ModalType.TYPE9;
    modalPart.modalWidth = LModalContentsWidthType.MODAL_TAB_W345;
    modalPart.closeBackEnable = false;
    modalPart.payload = this._currentSeatmapService.CurrentSeatmapData
      .notSelectableChildSeatInfoMap as ChildSeatNotSelectableConfirmationModalPayload;
    this._modalService.showSubModal(modalPart);
  }

  /** ストア情報設定 */
  public setSeatmapStore() {
    this._currentSeatmapService.updateCurrentSeatmap({
      notSelectableChildSeatInfoMap: new Map<string, NotSelectableChildSeatInfo>([
        [
          'PT1',
          {
            segmentId: 'ST1',
            departureAirportCode: 'HND',
            departureSurrogateName: 'HANEDA',
            arrivalAirportCode: 'CTS',
            arrivalSurrogateName: 'SAPPORO',
            seatNumber: '1A',
          },
        ],
      ]),
    });
  }

  /**
   * PNR情報取得レスポンスをストアにセットする
   * @param callback
   */
  private setGetOrderResponse(callback: () => void) {
    const request: GetOrderRequest = this.createGetOrderRequest();
    apiEventAll(
      () => {
        this._getOrderStoreService.setGetOrderFromApi(request);
      },
      this._getOrderStoreService.getGetOrderObservable(),
      (response) => {
        callback();
      }
    );
  }
  /**
   * 画面間受け渡し情報ストアにPNR情報をセットする
   */
  private setDeliveryInformation() {
    const currentDeliveryInformationStore: DeliveryInformationState = JSON.parse(
      JSON.stringify(this._deliveryInformationStoreService.deliveryInformationData)
    );

    let testSelectedSeatInformation: SelectedSeatInformation = {};
    this._getOrderStoreService.getOrderData.data?.air?.bounds?.[0].flights?.forEach((flight) => {
      testSelectedSeatInformation[flight.id ?? 'a'] = this.createSegmentInfo();
    });

    if (!currentDeliveryInformationStore.seatmapInformation) return;

    this._deliveryInformationStoreService.setDeliveryInformation(currentDeliveryInformationStore);
  }

  /**
   * テスト用の搭乗者情報リストを作成する
   * @returns 搭乗者情報
   */
  private createSegmentInfo(): SelectedSeatInformationSegment {
    return {
      passengerList: [
        {
          passengerId: '101',
          info: {
            seatNumbers: [''],
            seatType: {
              ssrCode: '',
            },
            ssrInfo: {
              updateType: '',
              ssrCode: '',
            },
            amount: '',
            isPasinet: false,
            isChildSeatEnable: false,
          },
        },
      ],
    };
  }

  /**
   * PNR情報取得APIリクエストパラメータ作成
   * @return リクエストパラメータ
   */
  private createGetOrderRequest() {
    return {
      orderId: '',
      travelDocumentId: '',
      credential: {
        firstName: '',
        lastName: '',
      },
      cartId: '',
      getServiceCatalogue: false,
      travelers: [],
      commonIgnoreErrorFlg: true,
    };
  }
}
